import { AskMatchRow } from './AskMatchRow';
import type { AskReviewRow } from '@/api/hooks/askSchemas';

export function LikelyRelatedTray({ rows, keptIds, onToggle }: { rows: AskReviewRow[]; keptIds: Set<string>; onToggle: (id: string) => void }) {
  if (rows.length === 0) return null;
  return (
    <div className="mt-2.5 rounded-lg border border-border bg-muted/30 p-2.5" data-testid="likely-related-tray">
      <div className="mb-1.5 text-xs text-muted-foreground">Likely related · {rows.length} · review before keeping</div>
      {rows.map((row) => <AskMatchRow key={row.line_item_id} row={row} kept={keptIds.has(row.line_item_id)} onToggle={onToggle} />)}
    </div>
  );
}

export default LikelyRelatedTray;
